import { ApiResult, post } from '@/utils/api';
import { ResultModel } from '@/model/viewModel';
import { CategoryModel, CategoryItemModel, CommodityModel } from '@/model/commdoity';

export const fetchCategoryList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/shop/food/category/select', data);

export const fetchCategoryItemList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/shop/food/select', data);

export const getCommodity = (data: any): Promise<ApiResult<CommodityModel>> =>
  post<CommodityModel>('/shop/food/selectOne', data);
